import React, { useStyles } from "react";
import { styleAlertBox } from "../../styles/alerts";

export const AlertSelectBox = ({  message, onConfirm, onCancel, titulo  }) => {
  const classes = styleAlertBox(); // Usa el hook de estilos

  return (
    <div className={classes.overlay}>
      <div className={classes.alertBox}>
        <h3 className={classes.title}>
          { titulo }
        </h3>
        <p className={classes.message}>{message}</p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
            <button className={classes.buttonCancel} onClick={onCancel}>
                Cancelar
            </button>
            <button className={classes.button} onClick={onConfirm}>
                Aceptar
            </button>
        </div>
      </div>
    </div>
  );
};

export default AlertSelectBox;
